import axios from 'axios';
import jsonpAdapter from 'axios-jsonp';
import {config} from './../config/config';

/**
 * 设置超时时间和跨域是否允许携带凭证
 */
axios.defaults.timeout = 10000; //10秒
axios.defaults.withCredentials = true;

/**
 * 设置post请求头
 * application/json;charset=UTF-8   JSON格式
 * application/x-www-form-urlencoded;charset=UTF-8  Form表单格式
 */
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.baseURL = config.baseUrl;

var CancelToken = axios.CancelToken;
let sources = []  // 定义数组用于存储每个ajax请求的取消函数及对应标识

/**
 * 请求防抖当一个url地址被请求多次就会取消前一次请求
 */
let removeSource = (config) => {
    for (let source in sources) {
        // 当多次请求相同时，取消之前的请求
        // if (sources[source].umet === config.url+'&'+config.method+'&'+config.data) {
        //     sources[source].cancel("取消请求")
        //     sources.splice(source, 1)
        // }
    }
}

/**
 * 请求拦截器
 */

axios.interceptors.request.use(config => {
	//防抖
	removeSource(config)
    config.cancelToken = new CancelToken((c) => {
        // 将取消函数存起来
        sources.push({ umet:config.url+'&'+config.method+'&'+config.data,cancel: c })
    })

    return config;
}, error => {
    return Promise.reject(error)
});

// 响应拦截器
axios.interceptors.response.use(config => {
    removeSource(config.config)

    return config.data;
}, error => {
    return Promise.reject(error)
});

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function get(url, params, headers={}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params,
            headers:headers
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err)
        })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
function post(url, params, config={}) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}`, params, config)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err)
            })
    });
}

function jsonp(url){
    return new Promise((resolve, reject) => {
        axios({
            url:url,
            adapter:jsonpAdapter,
        }).then(res => {
            resolve(res);
        })
        .catch(err => {
            reject(err)
        })
    });
}
//节流
function throttle(fn,delay){
    if(fn.timer){return}
    fn.timer=setTimeout(function(){
        fn();
        fn.timer=null;
    },delay);
}
//组件级className multiple
const cx=(...classNames)=>classNames.join(' ');

// 对外暴露
export { post, get,jsonp, throttle, cx}